// Shared project launcher and workbench navigation.
export const workspaceTools = [
  { id: 'video', label: '生视频', icon: 'VideoCamera', permission: 'video:page', names: ['VideoStudio', 'VideoDetail'] },
  { id: 'image', label: '生图', icon: 'Picture', permission: 'image:page', names: ['ImageGenerate', 'ImageGenerateStudio'] },
  { id: 'canvas', label: '画布', icon: 'Connection', permission: 'canvas:page', names: ['CanvasList', 'SmartCanvas'] },
  { id: 'subtitle', label: '去字幕', icon: 'Film', permission: 'subtitle_removal:page', names: ['SubtitleRemoval'] },
  { id: 'music', label: 'AI音乐', icon: 'Headset', permission: 'music:page', names: ['MusicGenerate'] },
  { id: 'voice', label: '配音', icon: 'Microphone', permission: 'voice:page', names: ['VoiceService'] },
  { id: 'assets', label: '素材库', icon: 'Files', permission: 'volc_asset:page', names: ['VolcAsset'] }
]

export const workspaceEntries = [
  { id: 'projects', label: '剧本项目', icon: 'FolderOpened', name: 'VideoList', permission: 'video:page' },
  { id: 'tables', label: '表格', icon: 'Grid', name: 'FeishuTables', permission: 'feishu:page' },
  { id: 'inspiration', label: '灵感素材库', icon: 'Collection', name: 'InspirationMaterial', permission: ['inspiration:page', 'inspiration:view'] },
  { id: 'scripts', label: '智能剧本', icon: 'Document', name: 'ScriptAgentWorkspace' },
  { id: 'quick-scripts', label: '快速剧本', icon: 'Document', name: 'QuickScriptWorkspace' }
]

export const workspaceNavigationKey = Symbol('workspace-navigation')
export const workspaceActivityKey = Symbol('workspace-activity')

export function activeWorkspaceTool(route) {
  return workspaceTools.find(tool => tool.names.includes(route.name))?.id || ''
}

export function workspacePageTitle(route) {
  const tool = workspaceTools.find(item => item.names.includes(route.name))
  if (tool) return tool.label
  if (route.matched?.some(record => record.path === '/quick-script')) return '快速剧本'
  if (route.matched?.some(record => record.path === '/script-agent')) return '智能剧本'
  return workspaceEntries.find(entry => entry.name === route.name)?.label || route.meta?.title || '于垣创作'
}

export function workspaceCacheKey(route) {
  // Keep a single instance per tool, including the script studio's nested router.
  // Changing projects within a tool still reaches its normal route watchers.
  if (route.matched?.some(record => record.path === '/quick-script')) return 'quick-script'
  if (route.matched?.some(record => record.path === '/script-agent')) return 'script-agent'
  if (['ImageGenerate', 'ImageGenerateStudio'].includes(route.name)) return 'image'
  return String(route.name || route.path)
}

export function workspaceToolLocation(id, scriptId, previous) {
  const script = scriptId == null ? '' : String(scriptId)
  if (id === 'video') return script ? { name: 'VideoStudio', params: { scriptId: script } } : { name: 'VideoList' }
  if (id === 'image') return script ? { name: 'ImageGenerateStudio', params: { scriptId: script } } : { name: 'ImageGenerate' }
  if (id === 'canvas') return previous || { name: 'CanvasList', query: script ? { scriptId: script } : {} }
  if (id === 'assets') {
    if (script) return { name: 'VolcAsset', query: { scriptId: script } }
    const previousScript = typeof previous === 'string'
      ? new URL(previous, 'http://workspace.local').searchParams.get('scriptId')
      : ''
    return previousScript ? { name: 'VolcAsset', query: { scriptId: previousScript } } : { name: 'VolcAsset' }
  }
  const tool = workspaceTools.find(item => item.id === id)
  if (!tool) return null
  // A canvas/editor selection belongs to the current workbench session.
  return previous || { name: tool.names[0] }
}

export function snapshotWorkspaceRoute(route) {
  return { ...route, params: { ...route.params }, query: { ...route.query }, meta: { ...route.meta }, matched: [...route.matched] }
}
